import { render, staticRenderFns } from "./DictionaryView.vue?vue&type=template&id=b1980530&scoped=true&"
import script from "./DictionaryView.vue?vue&type=script&lang=js&"
export * from "./DictionaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1980530",
  null
  
)

export default component.exports